const Metronome = ({ bpm, setBpm }) => {
  const interval = 60000.0 / bpm
  const [isPlaying, setIsPlaying] = useState(false)
  const toogleIsPlaying = useCallback(() => {
    return setIsPlaying((currentIsPlaying) => {
      return !currentIsPlaying
    })
  })

  const onUp = useCallback(() => {
    return setBpm(bpm + 1)
  })

  const onDown = useCallback(() => {
    return setBpm(bpm - 1)
  })

  const sound = useMemo(() => {
    return new Audio('/audio/tick.mp3')
  })

  const tick = useCallback(() => {
    if (!isPlaying) return
    sound.play()
  }, [isPlaying])

  useEffect(() => {
    const intervalId = setInterval(() => {
      tick()
    }, interval)

    // 2. Clean up the interval on component unmount
    return () => clearInterval(intervalId)
  }, [interval, tick])

  return (
    <div className="frow items-center">
      <div className="fcol items-center flex-1">
        <div className="btn btn-primary btn-icon btn-xl" onClick={onDown}>
          <i className="ph ph-minus" />
        </div>
      </div>
      <div
        className="flex-3 digital-display-wrapper digital-display-wrapper-big frow items-center justify-center"
        onClick={toogleIsPlaying}
      >
        <div
          className={clsx('digital-display', {
            'digital-display-disabled': !isPlaying
          })}
        >
          {bpm}
        </div>
        <i
          className={clsx('ph text-sm text-5xl', {
            'ph-play text-gray-500': !isPlaying,
            'ph-stop text-green-500': isPlaying
          })}
        />
      </div>
      <div className="fcol items-center flex-1">
        <div className="btn btn-primary btn-icon btn-xl" onClick={onUp}>
          <i className="ph ph-plus" />
        </div>
      </div>
    </div>
  )
}

const StandaloneMetronome = ({ initialBpm = 120 }) => {
  const [bpm, setBpm] = useState(initialBpm)

  return <Metronome bpm={bpm} setBpm={setBpm} />
}

const Test = () => {
  return (
    <div className="p-d">
      <div>1234</div>
      <StandaloneMetronome initialBpm={120} />
    </div>
  )
}

export default Test
